import { ReactElement } from 'react';

import { QueueUploadSeismic2DParam } from './params/QueueUploadSeismic2DParam';
import { QueueSeismicItemActions } from './QueueSeismicItemActions';
import { IItemActionsProps, QueueTypeHandler } from '../QueueTypeHandler';

export class UploadSeismic2DHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = ['.sgy','.segy'];

    renderParams(onParamsChange?: (params: Record<string, unknown>) => void, initialValues?: Record<string, string>): ReactElement {
        return <QueueUploadSeismic2DParam onParamsChange={onParamsChange} initialValues={initialValues} />;
    }

    renderItemActions(props: IItemActionsProps): ReactElement {
        return <QueueSeismicItemActions {...props} />;
    }
}
